import { z } from 'zod';

export const RiskAnalysisSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    _id: z.string().optional(),
    riskId: z.union([z.string(), z.number()]).optional(),
    analysisDate: z.string().optional(),
    analyst: z.string().optional(),
    analysisMethod: z.string().optional(),
    likelihood: z.number().min(1).max(5),
    impact: z.number().min(1).max(5),
    riskScore: z.number().optional(),
    riskLevel: z.string().optional(),
    score: z.number().optional(),
    justification: z.string().optional(),
    existingControls: z.string().optional(),
    controlEffectiveness: z.string().optional(),
    residualRisk: z.string().optional(),
    recommendations: z.string().optional(),
    nextReviewDate: z.string().optional(),
    status: z.string().optional(),
    analyzedBy: z.string().optional(),
    analyzedAt: z.union([z.string(), z.date()]).optional(),
    createdAt: z.union([z.date(), z.string()]).optional(),
    updatedAt: z.union([z.date(), z.string()]).optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateRiskAnalysisSchema = RiskAnalysisSchema.omit({ id: true, _id: true, createdAt: true, updatedAt: true });
export const UpdateRiskAnalysisSchema = RiskAnalysisSchema.partial();

// Frontend Form Schema
export const RiskAnalysisFormSchema = z.object({
    riskId: z.union([z.number(), z.string()]).optional(),
    analysisDate: z.string().min(1, "form.validation.analysisDateRequired"),
    analyst: z.string().min(1, "form.validation.analystRequired"),
    analysisMethod: z.string().min(1, "form.validation.analysisMethodRequired"),
    likelihood: z.number().min(1, "form.validation.likelihoodRequired").max(5),
    impact: z.number().min(1, "form.validation.impactRequired").max(5),
    existingControls: z.string().optional(),
    controlEffectiveness: z.string().optional(),
    residualRisk: z.string().optional(),
    recommendations: z.string().optional(),
    nextReviewDate: z.string().optional(),
});
